export const helinto = {
  companyName: 'FlySync',
  corporateName: 'Helinto',
  title: 'Helinto',
  templateConfig: 'template1',
  email: 'support@helinto.com',
  phone: '+91 9500120014',
  address:
    '<div><strong>Ghatala Towers</strong>, <br>Avenue Rd, Ponnangipuram, Tirumurthy Nagar, Nungambakkam, Chennai, Tamil Nadu 600034</div>',
  apiUrl: 'https://admin.helinto.com/backend/',
  isFullBGimage: 'Y',
  agentNavigate: '',
  isHotel: false,
  poweredBy: true,
  instagram: 'https://www.instagram.com/helinto_tours/',
  facebook: 'https://www.facebook.com/helinto/',
  twitter: '',
  linkedin: '',
  youtube: '',
  sentryDsn:
    'https://67269001d7387ce208d73a9eb29708e3@o4509110763126784.ingest.us.sentry.io/4509110770663424',
  registerAddress: '',
  registerCompanyName: '',
  registerEmail: '',
  registerMobile: '',
  registerNo: '',
  providerCodes: ['TBO'],
  cancellationCharges: '{"DO":"250","IN":"500"}',
  encrypt: 'N',
  securePayment: 'true',
};
